import type { StoryDirection } from '@rdd/contracts'

/** Setas e WASD (docs/21 secao 5). Qualquer outra tecla nao e movimento. */
const KEYS: Readonly<Record<string, StoryDirection>> = {
  ArrowUp: 'up',
  ArrowDown: 'down',
  ArrowLeft: 'left',
  ArrowRight: 'right',
  KeyW: 'up',
  KeyS: 'down',
  KeyA: 'left',
  KeyD: 'right',
}

export const directionOfKey = (code: string): StoryDirection | undefined => KEYS[code]
